import { FormTextField } from 'components/form';
import { Header } from 'components/ui-kit';
import React from 'react';

export const CommentForm = (): JSX.Element => {
  return (
    <>
      <Header weight="600" level={3}>
        Комментарий к заказу
      </Header>
      <FormTextField label="Текст комментария" name="comment" />
    </>
  );
};
